<template>
  <div class="createGroupExperiment">
    <v-row justify="center" no-gutters>
      <v-col cols="11" md="8" lg="6" class="my-2 px-1">
        <h5 class="ml-n5">{{ $t("manage.by_school.group_experiment.create_slot.header") }}</h5>
        <v-row>
          <v-col cols="12">
            <v-select
              :items="api.schools"
              item-text="school_id"
              item-value="school_id"
              v-model="form.school_id"
              :label="createGroupExperimentLabel('school_label')"
              :disabled="current.user_level!='ADMIN'"
              readonly
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-select
              v-if="$i18n.locale=='tc'"
              :items="api.experiments"
              item-text="experiment_set_chi"
              item-value="experiment_set"
              v-model="form.selected_experiment"
              :label="createGroupExperimentLabel('experiment_set_label')"
              no-data-text="沒有適用的實驗"
              @change="changeExperimentSet(form.selected_experiment);"
            ></v-select>
            <v-select
              v-else
              :items="api.experiments"
              item-text="experiment_set"
              item-value="experiment_set"
              v-model="form.selected_experiment"
              :label="createGroupExperimentLabel('experiment_set_label')"
              no-data-text="No Experiment Available"
              @change="changeExperimentSet(form.selected_experiment);"
            ></v-select>
          </v-col>
        </v-row>
        <hr>        
        <v-row>
          <v-col col="12">
            <small style="color: #868686; font-size: 12px;">
              {{ $t("manage.by_school.group_experiment.create_slot.date_range_label") }}
            </small>
            <br>
            <date-picker :placeholder="createGroupExperimentLabel('date_range_label')" v-model="form.dates" range @change="formatActualEndTime()"></date-picker>
          </v-col>
        </v-row>
        <hr>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.start_time"
              :label="createGroupExperimentLabel('start_time_label')"
              type="time"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.end_time"
              :label="createGroupExperimentLabel('end_time_label')"
              type="time"
              @change="formatActualEndTime()"
            ></v-text-field>
          </v-col>
        </v-row>
        <hr>
        <v-row>
          <v-col>
            <v-row align="center">
              <v-checkbox
                v-model="assignCheckbox"
                hide-details
                class="shrink mr-2 mt-0"
              ></v-checkbox>
              <v-select
                multiple
                chips
                :items="api.groups"
                item-text="user_group"
                item-value="user_group"
                v-model="form.groups"
                :label="createGroupExperimentLabel('assign_label')"
                :disabled="!assignCheckbox"
              ></v-select>
            </v-row>
          </v-col>
        </v-row>
        <v-btn class="ma-4" @click="openCreateGroupExperimentDialog();">
          {{ $t("manage.by_school.group_experiment.create_slot.btn_create_book_slot") }}
        </v-btn>
        <hr />
      </v-col>
    </v-row>
    <v-dialog v-model="createGroupExperimentDialog" max-width="600px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="createGroupExperimentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.group_experiment.create_slot.create.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" class="my-2 px-1">
            <table>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.group_experiment.create_slot.create.school") }}</th>
                <td>{{ form.school_id }}</td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.group_experiment.create_slot.create.experiment_set") }}</th>
                <td>{{ form.experiment }} - {{ form.equipment_id }}</td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.group_experiment.create_slot.create.start_time") }}</th>
                <td>{{ form.dates[0] | moment("YYYY-MM-DD") }} {{ form.start_time  }} <small>{{ $t("manage.by_school.group_experiment.create_slot.create.format_note") }}</small></td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.group_experiment.create_slot.create.end_time") }}</th>
                <td>{{ form.dates[1] | moment("YYYY-MM-DD") }} {{ form.end_time }} <small>{{ $t("manage.by_school.group_experiment.create_slot.create.format_note") }}</small></td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.group_experiment.create_slot.create.actual_end_time") }}</th>
                <td>{{ form.actual_end_time }} <small>{{ $t("manage.by_school.group_experiment.create_slot.create.format_note") }}</small></td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.group_experiment.create_slot.create.user_group") }}</th>
                <td v-if="assignCheckbox">{{ form.groups.toString() }}</td>
                <td v-else></td>
              </tr>
            </table>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="" text @click="createGroupExperimentDialog = false">
                {{ $t("manage.by_school.group_experiment.create_slot.create.btn_discard") }}
              </v-btn>
              <v-btn color="primary" text @click="createGroupExperiment">
                {{ $t("manage.by_school.group_experiment.create_slot.create.btn_create") }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment, { duration } from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// import 'vue2-datepicker/locale/zh-cn';
import { api_management } from "@/services/iot/api_management";
import { api_booking } from "@/services/iot/api_booking";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);
const apiBooking = new api_booking(process.env.VUE_APP_BASE_URL);
export default {
  components: { 
    DatePicker 
  },
  name: "CreateGroupExperiment",
  data: function () {
    return {
      createGroupExperimentDialog: false,
      assignCheckbox: false,
      menu: false,
      dialog: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      api: {
        groups: [],
        schools: [],
        experiment_sets: [],
        experiments: [
        ],
      },
      form: {
        selected_experiment: "",
        start_time: "",
        end_time: "",
        actual_end_time: "",
        school_id: "",
        dates: [],
        groups: [],
        experiment: "",
        equipment_id: "",
      },
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.api.schools = [self.current.school_id];
    self.form.school_id = self.current.school_id;
    apiManagement.getSchoolGroupExperiment(self.current.school_id).then((response) => {
      self.api.experiments = response.experiments;
    });    
    self.getSchoolUserGroups();
  },  
  methods: {
    isValid: function(){
      var self = this;
      
      let start_datetime = moment(self.form.dates[0]).format("YYYY-MM-DD") + " " + self.form.start_time;
      let end_datetime = moment(self.form.dates[1]).format("YYYY-MM-DD") + " " + self.form.end_time;

      let start_moment = moment(start_datetime, "YYYY-MM-DD HH:mm", true);
      let end_moment = moment(end_datetime, "YYYY-MM-DD HH:mm", true);
      let timeDiff = end_moment.diff(start_moment);

      if(self.form.experiment==""){
        alert("Fail! Missing experiment");
        return false;
      }
      if(self.form.equipment_id==""){
        alert("Fail! Missing experiment");
        return false;
      }
      if(self.form.dates[0]==null){
        alert("Fail! Missing start date");
        return false;
      }
      if(self.form.dates[1]==null){
        alert("Fail! Missing end date");
        return false;
      }
      if( self.form.start_time.trim()=="" ){
        alert("Fail! Missing start time");
        return false;
      }
      if( self.form.end_time.trim()=="" ){
        alert("Fail! Missing end time");
        return false;
      }
      if( moment(self.form.start_time, "HH:mm", true).isValid() == false){
        alert("Fail! Invalid time format of start time");
        return false;
      }
      if( moment(self.form.end_time, "HH:mm", true).isValid() == false){
        alert("Fail! Invalid time format of end time");
        return false;
      }
      if( end_moment.diff(start_moment) < 0 ){
        alert("Invalid Date and Time! Start time must be sooner than End time!");
        return false;
      }

      return true;
    },
    openCreateGroupExperimentDialog(){
      var self = this;
      if(self.isValid()){
        self.createGroupExperimentDialog = true;
      }
    },
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    changeExperimentSet(experiment_set){
      var self = this;
      let split = experiment_set.split(" - ");
      self.form.experiment = split[0];
      self.form.equipment_id = split[1];
    },
    createGroupExperiment: function () {
      var self = this;
      let groups = [];
      if(self.assignCheckbox){
        groups = self.form.groups;
      }
      if (self.isValid()) {
        let start_datetime =  moment(self.form.dates[0]).format("YYYY-MM-DD") + " " + self.form.start_time;
        let end_datetime = moment(self.form.dates[1]).format("YYYY-MM-DD") + " " + self.form.end_time;
        apiManagement.createGroupExperiment(
          self.form.school_id,
          self.form.experiment,
          self.form.equipment_id,
          start_datetime,
          end_datetime,
          groups,
          self.current.username
        )
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.createGroupExperimentDialog = false;
//            alert("Assigned " + response.count + " slots successfully");
          } else {
            alert(response.message);
          }
        });        
      }
    },
    getSchoolUserGroups(){
      var self = this;
      apiManagement.getSchoolUserGroups(self.current.school_id)
      .then((response) => {
          self.api.groups = response.groups;
      });
    },
    createGroupExperimentLabel(label){
      var self = this;
      if(label=='school_label') return self.$t("manage.by_school.group_experiment.school");
      else if(label=='experiment_set_label') return self.$t("manage.by_school.group_experiment.create_slot.experiment_set");
      else if(label=='date_range_label') return self.$t("manage.by_school.group_experiment.create_slot.date_range");
      else if(label=='start_time_label') return self.$t("manage.by_school.group_experiment.create_slot.start_time");
      else if(label=='end_time_label') return self.$t("manage.by_school.group_experiment.create_slot.end_time");
      else if(label=='assign_label') return self.$t("manage.by_school.group_experiment.create_slot.assign_to");
    },
    closeDialog() {
      this.$emit("update-parent-dialog", false);
    },
    formatActualEndTime(){
      var self = this;
      self.form.actual_end_time = moment(moment(self.form.dates[1]).format("YYYY-MM-DD") + " " + self.form.end_time, "YYYY-MM-DD HH:mm").subtract(5, "minutes").format("YYYY-MM-DD HH:mm");
      
    }
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>